(function () {
    let $body = $('body'),
        binders = UX.binders;

    binders._share = {
        $sharedEModal: $('#shareBinder'),
        $sharedEmail: $('.binder__share__form__input'),
        $sharedEmailSubmit: $('.binder__share__form__btn'),
        $sharedCount: $('.binder__share__list-section .count'),
        $sharedTable: $('.binder__share__list-section tbody'),
        $sharedBinderName: $('.binder__share__info-section .title'),
        $sharedBinderDesc: $('.binder__share__info-section .description'),
        $sharedAlertMsg: $('.binder__share__alerts__msg'),
        $unshareEmail: null,

        init() {
            this.control();
        },
        control() {
            $body.on('input', '.binder__share__form__input', e => {
                let $elem = $(e.target);
                this.$sharedEmailSubmit = $elem.closest('.binder__share__form').find('.binder__share__form__btn');

                if ($elem.val().trim() === '' || !/(.+)@(.+){2,}\.(.+){2,}/.test($elem.val().trim())) {
                    this.$sharedEmailSubmit.attr('disabled', 'disabled');
                } else {
                    this.$sharedEmailSubmit.removeAttr('disabled');
                }
            });

            $body.on('click', '.binder__tools__shareList', e => {
                this.initList(e);
            });

            this.$sharedEmailSubmit.on('click', e => {
                //share with new user
                e.preventDefault();
                this.shareWithUser(e);
            });

            $body.on('click', '[data-target="#unshareBinder"]', e => {
                // unshare
                this.$unshareEmail = $(e.target).closest('tr');
            });

            $body.on('click', '.binder__unshare__confirm', e => {
                // confirm unshare
                e.preventDefault();
                this.unshare();
            });

            $('#shareBinder').on('hidden.bs.modal', function () {
                $(
                    '.binder__share__list-section tbody, .binder__share__info-section .title, .binder__share__info-section .description, .binder__share__list-section .count'
                ).html('');
            });
        },

        initList(e) {
            this.$sharedAlertMsg.empty();
            let $this = $(e.target).closest('.binder__tools__shareList'),
                link = $this.attr('data-share-popup'), // real link
                // link = '/specs/ux3/widgets/binder-list/templates/demo/shareList.json', // test link
                $trElem = null,
                code = null,
                name = null,
                desc = null;
            $.ajax({
                url: link,
                type: 'GET',
                success: function (data) {
                    if (data) {
                        binders._share.$sharedCount.html(data.length);
                        binders._share.$sharedTable.html('');
                        if ($this.closest('.binder__issues__info').length) {
                            $trElem = $this.closest('.binder__issues');
                            code = $trElem.attr('data-binder-code');
                            name = $trElem.find('.binder__issues__header__name').text();
                            desc = $trElem.find('.binder__issues__description').text();
                        } else {
                            $trElem = $this.closest('tr');
                            code = $trElem.attr('data-binder-code');
                            name = $trElem.find('.binder__title h6').text();
                            desc = $trElem.find('.binder__description').text();
                        }

                        binders._share.$sharedBinderName.html(name);
                        binders._share.$sharedBinderDesc.html(desc);
                        binders._share.$sharedEModal.find('form').attr('data-binder-code', code);
                        binders._share.$sharedEmail.val('');
                        binders._share.$sharedEmailSubmit.attr('disabled', 'disabled');

                        data.forEach(function (element) {
                            let statusIcon = 'icon-checkmark';
                            if (
                                element.status.toLowerCase() === 'rejected' ||
                                element.status.toLowerCase() === 'canceled'
                            ) {
                                statusIcon = 'icon-close_thin';
                            }

                            let repDate = element.repliedDate ? element.repliedDate : '-';

                            binders._share.$sharedTable.append(`<tr>
                                                                        <td>${element.email}</td>
                                                                        <td class="invite-date">${element.invitedDate}</td>
                                                                        <td class="replied-date">${repDate}</td>
                                                                        <td class="status"><i class="${statusIcon}"></i><span>${element.status}</span></td>
                                                                        <td><a href="#" data-toggle="modal" data-target="#unshareBinder" title="remove user from Shared list"><i aria-hidden="true" class="icon-close_thin"></i></a></td>
                                                                    </tr>`);
                        });
                    }
                    binders._share.additionalInitList();
                },
            });
        },
        additionalInitList() {},
        shareWithUser(e) {
            let code = encodeURIComponent($(e.target).closest('form').attr('data-binder-code')),
                link = '/action/shareBinder?binderCode=' + code + '&email=', // real link
                // link = '/specs/ux3/widgets/binder-list/templates/demo/share.json?email=', // test link
                email = encodeURIComponent(this.$sharedEmail.val());
            $.ajax({
                url: link + email,
                type: 'GET',
                success: function (data) {
                    if (data.sharedBinder) {
                        binders._share.$sharedAlertMsg.html(binders.successHtml.replace(/{message}/g, data.message));
                        binders._share.$sharedTable.prepend(`<tr>
                                                                    <td>${data.sharedBinder.email} </td>
                                                                    <td class="invite-date">${data.sharedBinder.invitedDate}</td>
                                                                    <td class="replied-date"> - </td>
                                                                    <td class="status"><i class="icon-pending"></i><span>Pending</span></td>
                                                                    <td><a href="/" data-toggle="modal" data-target="#unshareBinder" title="remove user from Shared list"><i aria-hidden="true" class="icon-close_thin"></i></a></td>
                                                                </tr>`);
                    } else if (data.message) {
                        binders._share.$sharedAlertMsg.html(binders.successHtml.replace(/{message}/g, data.message));
                    }
                },
                error: function (data) {
                    if (data.responseJSON.message) {
                        binders._share.$sharedAlertMsg.html(
                            binders.warningHtml.replace(/{message}/g, data.responseJSON.message)
                        );
                    }
                },
            });

            setTimeout(function () {
                binders._share.$sharedAlertMsg.empty();
            }, 3000);
        },
        unshare() {
            let $this = this.$unshareEmail,
                code = $this.closest('form').attr('data-binder-code'),
                link = '/action/unShareBinder?binderCode=' + encodeURIComponent(code) + '&email=', // real link
                // link = '/specs/ux3/widgets/binder-list/templates/demo/unshare.json?email=', // test link
                email = encodeURIComponent($this.find('td:first-child').text());
            $.ajax({
                url: link + email,
                type: 'GET',
                success: function (data) {
                    if (data.message) {
                        binders._share.$sharedAlertMsg.html(binders.successHtml.replace(/{message}/g, data.message));
                        $this.remove();
                    }
                },
                error: function (data) {
                    if (data.responseJSON.message) {
                        binders._share.$sharedAlertMsg.html(
                            binders.warningHtml.replace(/{message}/g, data.responseJSON.message)
                        );
                    }
                },
            });

            $('#unshareBinder').modal('toggle');
            $body.removeAttr('data-active');

            setTimeout(function () {
                binders._share.$sharedAlertMsg.empty();
            }, 3000);
        },
    };
})();
